class ThankYouModal extends HTMLElement {
  constructor() {
    super();
    this.hashText = null;
    this.modal = null;
  }

  static defaultHashText = "#ContactForm";

  connectedCallback() {
    this.getAttributes();
    this.addListeners();
    const url = new URL(window.location.href);
    const hash = this.hashText ? this.hashText : ThankYouModal.defaultHashText;
    if (url.hash === hash && this.modal) {
      this.modal.classList.add("thank-you-modal--open");
    }
  }

  getAttributes() {
    this.hashText = this.getAttribute("datahash");
    this.modal = this.querySelector(".thank-you-modal");
  }

  addListeners() {
    if (this.modal) {
      this.modal.addEventListener("click", (event) => {
        if (
          event.target.closest(".thank-you-modal__close-buttons") ||
          event.target.classList.contains("thank-you-modal__overlay")
        ) {
          this.modal.classList.remove("thank-you-modal--open");
          window.location.hash = "";
          history.replaceState("", "", location.pathname);
        }
      });
    }
  }
}

if (!window.customElements.get("thank-you-modal")) {
  window.customElements.define("thank-you-modal", ThankYouModal);
}
